(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORE_TIME_ZONE = 'Australia/Sydney';
    var UNIT_LABELS = { daysOne: 'Day', daysOther: 'Days', hours: 'Hrs', minutes: 'Mins', seconds: 'Secs' };

    function getStoreParts(date) {
      var f = new Intl.DateTimeFormat('en-US', {
        timeZone: STORE_TIME_ZONE,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
      });
      var p = {};
      f.formatToParts(date).forEach(function (part) {
        if (part.type !== 'literal') p[part.type] = parseInt(part.value, 10);
      });
      if (p.hour === 24) p.hour = 0;
      return p;
    }

    function storeWallTimeToEpoch(y, mo, d, h, mi, s) {
      var guess = Date.UTC(y, mo - 1, d, h, mi, s);
      var p = getStoreParts(new Date(guess));
      var asIfUtc = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
      return guess - (asIfUtc - guess);
    }

    function nextStoreMidnight(from) {
      var p = getStoreParts(from);
      return storeWallTimeToEpoch(p.year, p.month, p.day + 1, 0, 0, 0);
    }

    function parseTarget(value) {
      var m = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2}))?)?$/);
      if (m) {
        return storeWallTimeToEpoch(+m[1], +m[2], +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0));
      }
      return Date.parse(value);
    }

    class BLCountdownTimer extends HTMLElement {
      connectedCallback() {
        this.autoMidnight = this.hasAttribute('auto-midnight');
        var targetAttr = this.getAttribute('target');
        this.fixedTarget = null;
        if (targetAttr) {
          var parsed = parseTarget(targetAttr);
          if (!isNaN(parsed)) this.fixedTarget = parsed;
        }
        if (this.fixedTarget == null && !this.autoMidnight) {
          this.hidden = true;
          return;
        }
        this._render();
        this._tick();
        this._interval = setInterval(this._tick.bind(this), 1000);
      }

      disconnectedCallback() {
        clearInterval(this._interval);
      }

      _resolveTarget(now) {
        if (this.fixedTarget != null && now < this.fixedTarget) return this.fixedTarget;
        if (this.autoMidnight) return nextStoreMidnight(new Date(now));
        return this.fixedTarget;
      }

      _tick() {
        var now = Date.now();
        var target = this._resolveTarget(now);
        if (target == null) { this.hidden = true; clearInterval(this._interval); return; }
        var diff = target - now;
        if (diff <= 0) {
          if (!this.autoMidnight) { this.hidden = true; clearInterval(this._interval); return; }
          diff = 0;
        }
        this._update({
          days: Math.floor(diff / 86400000),
          hours: Math.floor((diff % 86400000) / 3600000),
          minutes: Math.floor((diff % 3600000) / 60000),
          seconds: Math.floor((diff % 60000) / 1000),
        });
      }

      _render() {
        this.innerHTML =
          '<span class="bl-countdown__pill">' +
            '<span class="bl-countdown__unit bl-countdown__unit--days" data-days hidden>' +
              '<span class="bl-countdown__value">0</span><span class="bl-countdown__label">Days</span>' +
            '</span>' +
            '<span class="bl-countdown__unit"><span class="bl-countdown__value" data-hours>0</span><span class="bl-countdown__label">Hrs</span></span>' +
            '<span class="bl-countdown__unit"><span class="bl-countdown__value" data-minutes>0</span><span class="bl-countdown__label">Mins</span></span>' +
            '<span class="bl-countdown__unit"><span class="bl-countdown__value" data-seconds>0</span><span class="bl-countdown__label">Secs</span></span>' +
          '</span>';
        this._refs = {
          daysUnit: this.querySelector('[data-days]'),
          daysValue: this.querySelector('[data-days] .bl-countdown__value'),
          daysLabel: this.querySelector('[data-days] .bl-countdown__label'),
          hours: this.querySelector('[data-hours]'),
          minutes: this.querySelector('[data-minutes]'),
          seconds: this.querySelector('[data-seconds]'),
        };
      }

      _update(t) {
        var r = this._refs;
        if (!r) return;
        if (t.days > 0) {
          r.daysUnit.hidden = false;
          r.daysValue.textContent = t.days;
          r.daysLabel.textContent = t.days === 1 ? UNIT_LABELS.daysOne : UNIT_LABELS.daysOther;
        } else {
          r.daysUnit.hidden = true;
        }
        r.hours.textContent = t.hours;
        r.minutes.textContent = t.minutes;
        r.seconds.textContent = t.seconds;
      }
    }

    if (!customElements.get('countdown-timer')) {
      customElements.define('countdown-timer', BLCountdownTimer);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_featured-product-information-carousel"] && !Shopify.designMode) return;
  try {
    /** [BL] Custom media gallery: the dots follow the swipe and jump to their slide. */
  class BlCustomGallery extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.bl-custom-gallery__track');
      const dots = [...this.querySelectorAll('.bl-custom-gallery__dot')];
      if (!track || !dots.length) return;
      const slides = [...track.children];
      const setCurrent = (index) => dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      const observer = new IntersectionObserver(
        (entries) => entries.forEach((entry) => entry.isIntersecting && setCurrent(slides.indexOf(entry.target))),
        { root: track, threshold: 0.6 }
      );
      slides.forEach((slide) => observer.observe(slide));
      dots.forEach((dot, i) =>
        dot.addEventListener('click', () => {
          const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
        })
      );
    }
  }

  if (!customElements.get('bl-custom-gallery')) customElements.define('bl-custom-gallery', BlCustomGallery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["benefits-grid"] && !Shopify.designMode) return;
  try {
    /* Pills → details: open the accordion row that holds the List layout and bring it into view. */
  const openBenefitDetails = (/** @type {Event} */ event) => {
    const target = event.target instanceof Element ? event.target.closest('[data-bl-benefits-link]') : null;
    if (!target) return;
    const scope = target.closest('.product-details, .shopify-section') || document;
    const details = scope.querySelector('[data-bl-benefits-details]') || document.querySelector('[data-bl-benefits-details]');
    if (!details) return;
    for (let node = details.closest('details'); node; node = node.parentElement?.closest('details') ?? null) {
      node.open = true;
    }
    const row = details.closest('details') || details;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    row.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
  };
  document.addEventListener('click', openBenefitDetails);

  /* Pill tooltips are centred on their pill; nudge one that would leave the screen. */
  const placeBenefitTip = (/** @type {Event} */ event) => {
    const pill = event.target instanceof Element ? event.target.closest('.bl-benefits--pills .bl-benefit') : null;
    const tip = /** @type {HTMLElement | null | undefined} */ (pill?.querySelector('.bl-benefit__body'));
    if (!tip) return;
    tip.style.setProperty('--bl-tip-shift', '0px');
    const rect = tip.getBoundingClientRect();
    const margin = 12;
    let shift = 0;
    const width = document.documentElement.clientWidth;
    if (rect.left < margin) shift = margin - rect.left;
    else if (rect.right > width - margin) shift = width - margin - rect.right;
    tip.style.setProperty('--bl-tip-shift', `${shift}px`);
  };
  // Each pill can be reached by keyboard (and tapped on a phone) to show its tooltip, which it is
  // described by. Done on connect, so pills from a section re-render or the editor get it too.
  if (!customElements.get('bl-benefit-pills')) {
    customElements.define(
      'bl-benefit-pills',
      class extends HTMLElement {
        connectedCallback() {
          for (const pill of this.querySelectorAll('.bl-benefit')) {
            pill.setAttribute('tabindex', '0');
            const tip = pill.querySelector('.bl-benefit__body');
            if (tip?.id) pill.setAttribute('aria-describedby', tip.id);
          }
        }
      }
    );
  }
  document.addEventListener('pointerenter', placeBenefitTip, true);
  document.addEventListener('focusin', placeBenefitTip);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-table"] && !Shopify.designMode) return;
  try {
    /* Auto-highlights the size-table row whose match value equals the product's
     currently selected option (named by the table's data-bl-match-option).
     Re-syncs whenever a variant option changes. */
  (function () {
    function selectedValue(optionName) {
      if (!optionName) return null;
      var picker =
        document.querySelector('variant-picker[data-template-product-match="true"]') ||
        document.querySelector('variant-picker');
      if (!picker) return null;

      var esc = window.CSS && CSS.escape ? CSS.escape(optionName) : optionName;
      var radio = picker.querySelector('input[type="radio"][data-option-name="' + esc + '"]:checked');
      if (radio) return radio.value;

      var selects = picker.querySelectorAll('select');
      var want = ('options[' + optionName + ']').toLowerCase();
      for (var i = 0; i < selects.length; i++) {
        if ((selects[i].getAttribute('name') || '').toLowerCase() === want) return selects[i].value;
      }
      return null;
    }

    function sync() {
      var tables = document.querySelectorAll('.bl-size-table[data-bl-match-option]');
      for (var t = 0; t < tables.length; t++) {
        var selected = selectedValue(tables[t].getAttribute('data-bl-match-option'));
        var norm = selected == null ? null : String(selected).trim().toLowerCase();
        var rows = tables[t].querySelectorAll('.bl-size-row[data-bl-match-value]');
        for (var r = 0; r < rows.length; r++) {
          var v = (rows[r].getAttribute('data-bl-match-value') || '').trim().toLowerCase();
          rows[r].classList.toggle('bl-size-row--active', norm != null && v !== '' && v === norm);
        }
      }
    }

    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('variant-picker')) sync();
    });

    if (document.readyState !== 'loading') sync();
    else document.addEventListener('DOMContentLoaded', sync);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    /* Close the Option-Swatch-Sources dropdown once a value is picked. */
  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!target || target.type !== 'radio') return;
    const details = target.closest?.('.variant-option__vss-details');
    if (details) details.open = false;
  });
  } catch(e) { console.error(e); }
})();

})();
